import Vue from "vue";
//模块功能：港口查询
export default Vue.extend({
    name: "port-info",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.portinfo');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/port-info.vue
// module id = null
// module chunks = 